import type React from 'react';
import { ModerationStatusViewer } from '@features/common/SmallCardStatus/ModerationStatus/index.tsx';
import { useProgramAuthor } from '@features/programs';
import { ArrowShortLeft, SunDay } from '@shared/assets';
import type { Program } from '@shared/types/programs';
import { IconButton, PageHead } from '@shared/ui';
import { CommentsSmallButton } from '@shared/ui/likes_comments/CommentsSmallButton/index.tsx';
import { LikesSmallButton } from '@shared/ui/likes_comments/LikesSmallButton/index.tsx';
import { useLikeProgramMutation } from '@src/api/api-hooks/programs/useLikeProgramMutation.ts';
import { useRemoveProgramLikeMutation } from '@src/api/api-hooks/programs/useRemoveProgramLikeMutation.ts';
import type { Mode } from 'library/types/programs';
import * as st from './Head.module.scss';

type Props = {
  selectedDay: number;
  changeMode: (mode: Mode) => void;
  resetSelectedDay: () => void;
  onClose: () => void;
  Menu?: JSX.Element;
  program?: Program;
};

const Head: React.FC<Props> = ({
  selectedDay,
  changeMode,
  resetSelectedDay,
  onClose,
  Menu,
  program,
}) => {
  // const { program } = useProgram(programId);

  const { isAuthor } = useProgramAuthor(program?.author.id);

  const { mutateAsync: like } = useLikeProgramMutation();
  const { mutateAsync: removeLike } = useRemoveProgramLikeMutation();

  const openDaySelector = () => {
    changeMode('days');
    resetSelectedDay();

    // Скроллим на выбор дня
    // const player = document.getElementById('video-anchor');
    // player?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <PageHead
      Left={
        <div className={st.toolbar__left}>
          <button className={st.toolbar__back} onClick={onClose} id="close-program">
            <div className={st.toolbar__back_icon}>
              <ArrowShortLeft />
            </div>
          </button>
        </div>
      }
      Right={
        <>
          {program && isAuthor && (
            <ModerationStatusViewer
              isNeedToShowOnlyIcon={true}
              isPublished={program.publication?.is_published || false}
              moderationStatus={program.moderation_status}
            />
          )}
          {program && program?.with_likes && (
            <LikesSmallButton
              isLiked={program.liked}
              likesCount={program.likes}
              onLike={() => like({ id: String(program.pk) })}
              onRemoveLike={() => removeLike({ id: String(program.pk) })}
            />
          )}
          {program && program?.with_comments && (
            <CommentsSmallButton count={program.comments.length} />
          )}
          {program && 'periodicity' in program && program?.periodicity && (
            <div className={st.toolbar__buttons}>
              <div className={st.toolbar__day} onClick={openDaySelector}>
                <IconButton variant="dark" className={st.selectDay}>
                  <SunDay />
                  <span style={{ fontSize: 14 }}>{selectedDay}</span>
                </IconButton>
              </div>
            </div>
          )}
          {Menu}
        </>
      }
    />
  );
};

export default Head;
